import {getRequest, postRequest} from '../../utils/api'

function getSystemSetList(callback, failCallback, form) {
    postRequest("/systemSet/list", form).then(res => {
        
        callback(res);
    }, err => {
        failCallback(err);
    });
}

function getSystemSet(callback, failCallback, form) {
    postRequest("/systemSet/getSystemSet", form).then(res => {
        
        callback(res);
    }, err => {
        failCallback(err);
    });
}

function addSystemSet(callback, failCallback, form) {
    
    postRequest("/systemSet/add", form).then(res => {
        callback(res);
    }, err => {
        failCallback(err);
    });
}

function updateSystemSet(callback, failCallback, form) {
    
    postRequest("/systemSet/update", form).then(res => {
        callback(res);
    }, err => {
        failCallback(err);
    });
}

function deleteSystemSet(callback, failCallback, id) {
    postRequest("/systemSet/delete", {
        id: id
    }).then(res => {
        callback(res);
    }, err => {
        failCallback(err);
    });
}

function checkSystemSetExist(callback, failCallback, id) {
    postRequest("/systemSet/checkExist", {
        id: id
    }).then(res => {
        callback(res);
    }, err => {
        failCallback(err);
    });
}

function findSystemSetList(callback, failCallback, form) {
    postRequest("/systemSet/queryList", {
        ids: form
    }).then(res => {
        callback(res);
    }, err => {
        failCallback(err);
    });
}

function batchSet(callback, failCallback, form) {
    postRequest("/systemSet/batchSet", {
        list: form
    }).then(res => {
        callback(res);
    }, err => {
        failCallback(err);
    });
}


export default {
    getSystemSetList,
    addSystemSet,
    updateSystemSet,
    deleteSystemSet,
    checkSystemSetExist,
    findSystemSetList,
    batchSet,
    getSystemSet

}


// WEBPACK FOOTER //
// ./src/components/system/SystemSetModel.js